import {getMorphoService, serviceNames} from '@/rte/editor';
import {findNodeById, getEditor} from './utils';
import {MorphoNodeEntry} from './typings';

const getCurrentCard = (builderId: string): MorphoNodeEntry | null => {
    const editor = getEditor();
    if (!editor) {
        return null;
    }
    const thisFlexBuilderNode = findNodeById(builderId, editor.children, [], 'builderId');
    if (thisFlexBuilderNode && thisFlexBuilderNode[0]) {
        const nodeService = getMorphoService(serviceNames.INodeService);
        let parentNode = nodeService.parent(editor, thisFlexBuilderNode[1]);
        let type = parentNode.type;
        let parentPath = thisFlexBuilderNode[1].slice(0, -1);
        while (type !== 'card') {
            parentNode = nodeService.parent(editor, parentPath);
            if (!parentNode) {
                break;
            }
            type = parentNode.type;
            if (!type) {
                break;
            }
            parentPath = parentPath.slice(0, -1);
            if (parentPath.length === 0) {
                break;
            }
        }
        if (type === 'card') {
            return [parentNode, parentPath];
        }
    }
    return null;
};

export {getCurrentCard};
